<div class="logo">
	<img src="assets/images/logos/logo_Gauzy.svg" />
	<h4>{{ 'ONBOARDING.COMPLETE' | translate }}</h4>
	<h6>Where would you like to go now?</h6>
</div>

<ng-container *ngFor="let block of blocks$ | async">
	<div class="row centered">
		<ng-container *ngFor="let row of block">
			<div class="col-3">
				<nb-card
					class="shortcut-card"
					[status]="row?.status"
					(click)="navigateTo(row?.link)"
				>
					<nb-card-header>
						<nb-icon [icon]="row?.icon" *ngIf="row?.icon"></nb-icon>
						{{ row?.name }}
					</nb-card-header>
					<nb-card-body>
						<div class="shortcut">
							<div>
								{{ row?.description }}
							</div>
						</div>
					</nb-card-body>
				</nb-card>
			</div>
		</ng-container>
	</div>
</ng-container>
